<template>
  <v-row>
    <v-col cols="12">
      <responsibleProfile v-if="convocation_form.convocation_form.user_id===user.user_id" />
      <noResponsibleProfile v-if="convocation_form.convocation_form.user_id!==user.user_id" />
    </v-col>

    <v-col cols="12" class="pt-8 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'convocation'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
      <v-spacer />
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'
  import responsibleProfile from '@/components/entrepreneur/convocation/team/responsibleProfile.vue'
  import noResponsibleProfile from '@/components/entrepreneur/convocation/team/noResponsibleProfile.vue'

  export default {
    name: 'myTeam',
    components: {
      responsibleProfile,
      noResponsibleProfile,
    },
    data: () => ({
      aux:null, 
      show: false,
      id: null,
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'user'
      ])
    }
  }
</script>